
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function CommonConcerns() {
  const heading = useFadeIn({ direction: 'up' });
  const body = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-3xl mx-auto text-center space-y-12">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide font-serif">
            多くの方が、同じところで迷っています。
          </h2>
        </div>
        
        <div ref={body.ref} style={body.style}>
          <div className="space-y-3 text-gray-700 text-base md:text-lg font-light leading-loose">
            <p>マウスピース矯正が本当に自分に合うのか</p>
            <p>続けられるのか</p>
            <p>見た目だけでなく、結果に納得できるのか</p>
          </div>
          
          <p className="text-gray-600 text-base md:text-lg font-light leading-loose pt-3 mt-12">
            そう感じるのは、とても自然なことです。
          </p>
        </div>
      </div>
    </section>
  );
}
